import { Link } from "react-router-dom";

/* ICONS */
import { MdOutlineSpaceDashboard, MdContactSupport, MdMedicalServices } from "react-icons/md";
import { RiRefreshLine, RiArrowLeftRightLine, RiSettings3Line, RiArticleLine } from "react-icons/ri";
import { TbRepeat } from "react-icons/tb";

/* ASSETS */
import Logo from "../../assets/images/logo-light.png";

const NavLink = ({ to, icon: Icon, label }) => {
  const pathname = window.location.pathname;
  const active = pathname === to || pathname.startsWith(`${to}/`);

  return (
    <Link
      to={to}
      className={`mt-1 w-full group flex items-center gap-3 ${
        active ? "bg-white/10 text-white" : "text-sidebarText"
      } rounded-md py-2.5 px-3`}
    >
      <Icon className="w-5 h-5 transition-all duration-300 ease-in-out" />
      <p className="text-base font-ibm-regular leading-none transition-all duration-300 ease-in-out">
        {label}
      </p>
    </Link>
  );
};

const Sidebar = () => {
  return (
    <section className="h-screen w-sidebar bg-black transition-all duration-300 ease-linear">
      {/* HEADER */}
      <div className="border-b border-white border-opacity-20 p-5 flex items-center">
        <img
          src={Logo}
          className="w-36 object-contain"
          alt="WellCare Pharmacy"
        />
      </div>

      {/* NAVIGATION OPTIONS */}
      <div className="h-[85vh] flex flex-col justify-between overflow-y-auto hide-scrollbar">
        <div className="py-5 px-2">
          {/* OVERVIEW */}
          <div className="mt-0">
            <p className="pl-3 text-xs font-ibm-regular text-white/60">
              OVERVIEW
            </p>
            <div className="mt-3">
              <NavLink to="/dashboard" icon={MdOutlineSpaceDashboard} label="Dashboard" />
            </div>
          </div>

          {/* MANAGE LEADS */}
          <div className="mt-8">
            <p className="pl-3 text-xs font-ibm-regular text-white/60">
              MANAGE LEADS
            </p>
            <div className="mt-3">
              <NavLink to="/contact-requests" icon={MdContactSupport} label="Contact Requests" />
              <NavLink to="/refill-requests" icon={RiRefreshLine} label="Refill Requests" />
              <NavLink to="/transfer-requests" icon={RiArrowLeftRightLine} label="Transfer Requests" />
              <NavLink to="/auto-rx-requests" icon={TbRepeat} label="Auto Rx Enrollments" />
            </div>
          </div>

          {/* WEBSITE CONTENT */}
          <div className="mt-8">
            <p className="pl-3 text-xs font-ibm-regular text-white/60">
              WEBSITE CONTENT
            </p>
            <div className="mt-3">
              <NavLink to="/services" icon={MdMedicalServices} label="Services" />
              <NavLink to="/blogs" icon={RiArticleLine} label="Health Blogs" />
              <NavLink to="/site-settings" icon={RiSettings3Line} label="Site Settings" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sidebar;
